// Separately defined tags to prevent circular dependencies

export const applicationsTags = {
  applications: 'applications',
  application: 'application',
  applicant: 'applicant',
};
